var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(142, 218, 127, 0.14901960784313725)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(142, 218, 127, 0.14901960784313725)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,50L10,55C20,60,40,70,60,70C80,70,100,60,120,58.3C140,57,160,63,180,65C200,67,220,63,240,63.3C260,63,280,67,300,65C320,63,340,57,360,45C380,33,400,17,420,23.3C440,30,460,60,480,71.7C500,83,520,77,540,66.7C560,57,580,43,600,43.3C620,43,640,57,660,56.7C680,57,700,43,720,33.3C740,23,760,17,780,20C800,23,820,37,840,46.7C860,57,880,63,900,66.7C920,70,940,70,960,65C980,60,1000,50,1020,53.3C1040,57,1060,73,1080,80C1100,87,1120,83,1140,70C1160,57,1180,33,1200,35C1220,37,1240,63,1260,76.7C1280,90,1300,90,1320,81.7C1340,73,1360,57,1380,50C1400,43,1420,47,1430,48.3L1440,50L1440,100L1430,100C1420,100,1400,100,1380,100C1360,100,1340,100,1320,100C1300,100,1280,100,1260,100C1240,100,1220,100,1200,100C1180,100,1160,100,1140,100C1120,100,1100,100,1080,100C1060,100,1040,100,1020,100C1000,100,980,100,960,100C940,100,920,100,900,100C880,100,860,100,840,100C820,100,800,100,780,100C760,100,740,100,720,100C700,100,680,100,660,100C640,100,620,100,600,100C580,100,560,100,540,100C520,100,500,100,480,100C460,100,440,100,420,100C400,100,380,100,360,100C340,100,320,100,300,100C280,100,260,100,240,100C220,100,200,100,180,100C160,100,140,100,120,100C100,100,80,100,60,100C40,100,20,100,10,100L0,100Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.b8a2b986079c06fa70ef4c23af2b0a29.svg";
export { ForwardRef as ReactComponent };